import { Mediator, app, payload } from "modular-openscriptjs";
import { eParse, inform, processStart, processEnd } from "../helpers";
import { STRINGS, api } from "../declarations";
import { routes } from "../backendRoutes";

const $e = app("$e");

export class Review extends Mediator {
	$$review = {
		needs: {
			creation: (ed, event) => {
				this.broadcast($e.review.needs.reviewForm, ed);
			},
			storage: (ed, event) => {
				this.saveReview(ed, event);
			},
		},
	};

	async saveReview(ed, event) {
		let { message } = eParse(ed);

		let url = `${routes.orders}/${message.get("orderId", 0)}/review`;

		if (message.get("id") > 0) {
			url = `${routes.reviews}/${message.get("id")}`;
		}

		processStart({ title: "Saving Review" });
		let res = await api.put(url, message);

		processEnd();

		if (!res) {
			return this.send($e.review.has.storageError, ed);
		}

		inform(res.message, STRINGS.SUCCESS);

		return this.send(
			$e.review.stored,
			payload({ review: res.data.review }, eParse(ed).meta)
		);
	}
}
